var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c("v-container", [
        _c("h2", { staticClass: "myTitle" }, [_vm._v("Passwort zurücksetzen")]),
        _vm.sended
          ? _c("div", { staticClass: "indented text-center" }, [
              _c("h4", [
                _vm._v(
                  "Die E-Mail zum Zurücksetzen deines Passwortes wurde erfolgreich versendet an: " +
                    _vm._s(_vm.email)
                ),
              ]),
            ])
          : _c(
              "div",
              { staticClass: "indented text-center pa-3" },
              [
                _vm._v(
                  " Bitte gib deine E-Mail Adresse ein, um einen Link zum Zurücksetzen deines Passwortes zu erhalten: "
                ),
                _c("div", { staticClass: "spacer-15" }),
                _c(
                  "div",
                  { staticStyle: { margin: "auto", width: "60%" } },
                  [
                    _c("v-text-field", {
                      staticClass: "roundInput",
                      attrs: {
                        outlined: "",
                        label: "E-Mail",
                        outline: "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "spacer-25" }),
                _c("div", { staticClass: "spacer-25" }),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary", rounded: "" },
                    nativeOn: {
                      "&click": function ($event) {
                        return _vm.doResetPassword.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Email zum Zurücksetzen senden ")]
                ),
              ],
              1
            ),
        _c("div", { staticClass: "spacer-25" }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }